export {
  VisuallyHidden,
  //
  Root,
} from './visually-hidden';
export type { VisuallyHiddenProps } from './visually-hidden';
